export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx1_buy.54bcc6d4.mp3";